import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Public movement pages only. Directory analytics are first-party and separate.
export default function GaTracker() {
  const location = useLocation();
  useEffect(() => {
    window.docmSetAnalyticsRoute?.();
    if (typeof window.gtag === "function" && window.docmAnalyticsAllowed?.()) {
      window.docmLoadAnalytics?.();
      window.gtag('set', { page_location: window.location.origin + location.pathname, page_referrer: '' });
      window.gtag("event", "page_view", {
        page_path: location.pathname,
        page_location: window.location.origin + location.pathname,
        page_referrer: '',
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}
